const state = {
    mainSize: {
        left:{
            xs: "12",
            sm: "12",
            md: "6",
            lg: "6",
            xl: "4"
        },
        right:{
            xs: "12",
            sm: "12",
            md: "6",
            lg: "6",
            xl: "8"
        }
    },
    itemSize: {
        left:{
            xs: "12",
            sm: "12",
            md: "6",
            lg: "6",
            xl: "4"
        },
        right:{
            xs: "12",
            sm: "12",
            md: "6",
            lg: "6",
            xl: "8"
        },
    }
}
const getters = {
    getPageSize: () => {
        return state.mainSize
    },
    getPageItemSize: () => {
        return state.itemSize
    }
}
const mutations = {

}
const actions = {
}

export default{
    state,
    mutations,
    getters,
    actions
}